import api from "../api";
import axiosClient from "../utils/axiosClient";

const getCountries = async () => {
  const response = await axiosClient.get(api.FILTERS.COUNTRIES);
  return response.data;
};

const getStates = async () => {
  const response = await axiosClient.get(api.FILTERS.STATES_TYPES);
  return response.data;
};

const getPaymentTypes = async () => {
  const response = await axiosClient.get(api.FILTERS.PAYMENT_TYPES);
  return response.data;
};

const getParcelGroupContentTypes = async () => {
  const response = await axiosClient.get(
    api.FILTERS.PARCEL_GROUP_CONTENT_TYPES
  );
  return response.data;
};
const getParcelContentTypes = async (params) => {
  const response = await axiosClient.get(api.FILTERS.PARCEL_CONTENT_TYPES, {
    params,
  });
  return response.data;
};

const getCooperationTypes = async () => {
  const response = await axiosClient.get(api.FILTERS.COOPERATION_TYPES);
  return response.data;
};

const getCostTypes = async () => {
  const response = await axiosClient.get(api.FILTERS.COST_TYPES);
  return response.data;
};

const service = {
  getCountries,
  getPaymentTypes,
  getParcelContentTypes,
  getParcelGroupContentTypes,
  getCooperationTypes,
  getStates,
  getCostTypes,
};

export default service;
